const launchButtons = document.querySelector('#start-chatbot');
  const openKodifChat = () => {
    const iframe = document.getElementById('kodif-chat-widget');
    if (iframe) {
      iframe.contentWindow.postMessage({ type: 'toggle-expanded', isExpanded: true }, '*');
      return true;
    }
    return false;
  };
  launchButtons.addEventListener('click', () => {
    if (!openKodifChat()) {
      console.warn('Iframe not ready yet. Waiting...');
    }
  });